<template>
  <div>
    <b-img
      :src="imgUrl"
      alt="Icon"
    />
  </div>
</template>

<script>
import { BImg } from "bootstrap-vue"

export default {
  components: {
    BImg,
  },
  data() {
    return {
      imgUrl: require("@/assets/images/logo/webicon.png"),
    }
  },
}
</script>
